<template>
  <div>
    <img
      class="cursor-pointer"
      :src="`${fileUrl}${imgStr}`"
      alt=""
      :style="setStyle"
      @click="viewImgScreen"
    />
    <el-image
      v-show="false"
      ref="elImage"
      :src="`${fileUrl}${imgStr}`"
      :preview-src-list="imgPreviewList"
      lazy
    ></el-image>
  </div>
</template>

<script>
export default {
  name: 'question-view-img',
  props: {
    imgStr: {
      type: String,
      default: '',
    },
    setStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgPreviewList: [],
      imgContent: null,
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  watch: {
    imgStr: {
      handler(newVal) {
        if (newVal) {
          this.imgPreviewList.push(`${this.fileUrl}${this.imgStr}`)
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 预览图片，直接做预览，而非请求接口
    viewImgScreen() {
      this.imgPreviewList = []
      this.imgPreviewList.push(`${this.fileUrl}${this.imgStr}`)
      this.$nextTick(() => {
        this.$refs.elImage.clickHandler()
      })
    },
  },
}
</script>
